import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import {UserService} from '../../services/user';
import Editor from '@monaco-editor/react';
// import { highlight, languages } from 'prismjs/components/';
import Prism from 'prismjs';
import "prismjs/components/prism-json";
import {VideoPlayer} from '../../components';
import ElementVideoInteractive1Edit from './element-video-interactive-1-edit';
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";
import './element-video-interactive-1.css';

export default class ElementVideoInteractive1 extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      "active_mode": "preview",
      "current_layer": null,
      "current_time": null,
      "current_layer_width": "1920px",
      "current_layer_height": "1080px",
      "render_initial_frame": true,
      "edit_current_layer": null
    }
  }

  handleChange(content) {
    this.props.onChange(content);
  }

  componentDidMount() {
    this.setInitialLayer();
  }

  setInitialLayer() {
    var _this = this;
    var content = this.props.content;
    if (!content.layers || !content.layers[0]) return;
    this.setState({
      "current_layer": content.layers[0]
    }, function() {
      // document.getElementById(content.layers[0].id).play()
      _this.observeVideoTime()
    })
  }

  observeVideoTime() {
    var _this = this;
    var layer = this.state.current_layer;
    if (!layer) return;

    var video = document.getElementById(`player-${layer.id}`);
    if (!video || video._rdp_observed) return;
    video._rdp_observed = true;

    video.addEventListener("seeking", () => { video._rdp_seeking = true; });
    video.addEventListener("seeked", () => { video._rdp_seeking = false; });

    video.addEventListener("timeupdate", () => {
      if (!video._rdp_seeking) {
        _this.checkInteractions(Number(video.currentTime.toFixed(0)));
      }
    });

    video.addEventListener("loadedmetadata", function() {
      _this.setState({
        "current_layer_width": `${video.videoWidth}px`,
        "current_layer_height": `${video.videoHeight}px`
      });
    }, false);
  }

  checkInteractions(time) {
    var _this = this;
    this.setState({
      "current_time": time
    })

    var layer = this.state.current_layer;
    var interactions = layer.interactions;

    for (var i = 0; i < interactions.length; i++) {
      var interaction = interactions[i];
      if (interaction.type === "hotspot" && interaction.breakpoint === time) {
        var video = document.getElementById(`player-${layer.id}`);
        video.pause();
      } else if (interaction.type === "automatic" && interaction.breakpoint === time) {
        _this.onInteractionClick(interaction)
      }
    }
  }

  getVideoUrl(video) {
    var accessToken = UserService.getUser().access_token;
    if (video.search("https://pocs.digitalpages.com.br/rdpcomposer/media/") === -1) {
      video += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return video;
  }

  onInteractionClick(interaction) {
    var _this = this;
    var content = this.props.content;
    var layer = this.state.current_layer;

    if (interaction.target.layer !== "current") {
      const targetLayer = content.layers.find(item => item.id === interaction.target.layer);
      if (!targetLayer) return;
      this.setState({
        "current_layer": targetLayer
      }, function() {
        const playAndObserve = () => {
          const player = document.getElementById(`player-${interaction.target.layer}`);
          if (!player) return;
          if (interaction.target.autoplay) {
            player.currentTime = interaction.target.time;
            player.play().catch(() => setTimeout(playAndObserve, 100));
          }
          _this.observeVideoTime();
        };
        playAndObserve();
      });
    } else {
      const player = document.getElementById(`player-${layer.id}`);
      player.pause();
      player.currentTime = interaction.target.time;
      player.play().catch(() => {
        setTimeout(() => player.play(), 100);
      });
    }
  }

  onSelectMode(mode) {
    var content = this.props.content;

    if (mode === "edit") {
      this.setState({
        "edit_current_layer": content.layers.length > 0 ? content.layers[0].id : null
      })
    }


    this.setState({
      "render_initial_frame": true,
      "active_mode": mode
    })
  }

  onInitialFramePlay() {
    var _this = this;
    var layer = this.state.current_layer;
    if (!layer) return;
    var player = document.getElementById(`player-${layer.id}`);
    if (!player) return;
    player.play().then(() => {
      _this.observeVideoTime();
    }).catch(console.error);
    this.setState({ "render_initial_frame": false });
  }

  onEditLayerClick(layer) {
    this.setState({
      "edit_current_layer": layer.id
    })
  }

  getEditCurrentLayer() {
    return this.props.content.layers.find(layer => layer.id === this.state.edit_current_layer);
  }

  formatJSON(val = {}) {
    try {
      return JSON.stringify(val, null, 2)
    } catch {
      const errorJson = {
        "error": `非法返回${val}`
      }
      return JSON.stringify(errorJson, null, 2)
    }
  }

  handleEditorChange(value, event) {
    this.props.onChange(JSON.parse(value))
    console.log(JSON.parse(value));
  }

  getVideoHeight() {
    const {
      current_layer_width,
      current_layer_height
    } = this.state;

    return `${(Number(current_layer_height.split("px")[0]) * (740 / Number(current_layer_width.split("px")[0]))) + 70}px`
  }

  render() {
    var _this = this;
    const {
      active_mode,
      current_layer,
      current_time,
      current_layer_width,
      current_layer_height,
      render_initial_frame,
      edit_current_layer
    } = this.state;

    let { headerActionsTemplate, footerActionsTemplate, content, editable } = this.props;
    var imageStyle = {
      background: content.background_color,
      paddingTop: content.padding_top + "px",
      paddingBottom: content.padding_bottom + "px"
    }
    // const videoJsOptions = {
    //   responsive: true,
    //   autoplay: true,
    //   controls: true,
    //   playbackRates: [0.5, 1, 1.5, 2],
    //   sources: [{
    //     src: this.getVideoUrl(content.video)
    //   }]
    // }

    var scale = 740 / Number(current_layer_width.split("px")[0]);

    return (<div className="element-video-interactive-1" style={imageStyle}>
      {headerActionsTemplate}
      {/* <VideoPlayer { ...videoJsOptions } /> */}

      {}

      {editable &&
        <ul className="element-video-interactive-1-mode-btns">
          <li className={`element-video-interactive-1-mode-btn ${active_mode === "preview" ? "active" : ""}`} onClick={() => this.onSelectMode("preview")}>
            <span className="element-video-interactive-1-mode-btn-icon play"></span>
            <span className="element-video-interactive-1-mode-btn-label">Modo Preview</span>
          </li>
          <li className={`element-video-interactive-1-mode-btn ${active_mode === "edit" ? "active" : ""}`} onClick={() => this.onSelectMode("edit")}>
            <span className="element-video-interactive-1-mode-btn-icon edit"></span>
            <span className="element-video-interactive-1-mode-btn-label">Modo Edição</span>
          </li>
          <li className={`element-video-interactive-1-mode-btn ${active_mode === "json" ? "active" : ""}`} onClick={() => this.onSelectMode("json")}>
            <span className="element-video-interactive-1-mode-btn-icon json"></span>
            <span className="element-video-interactive-1-mode-btn-label">Modo JSON</span>
          </li>
        </ul>
      }

      {active_mode === "json" &&
        <Editor
          width="800px"
          height="500px"
          defaultLanguage="javascript"
          defaultValue={this.formatJSON(content)}
          onChange={(value, editor) => this.handleEditorChange(value, editor)}
        />
        // <Editor
        //   value={content}
        //   onValueChange={code => this.props.onChange(code)}
        //   highlight={code => Prism.highlight(JSON.stringify(code, null, 2), Prism.languages.json, 'json')}
        //   // highlight={code => Prism.highlight(JSON.stringify(code), Prism.languages.json, 'json')}
        //   padding={10}
        //   style={{
        //     fontFamily: '"Fira code", "Fira Mono", monospace',
        //     fontSize: 12,
        //   }}
        // />
      }

      {active_mode === "edit" &&
        <ElementVideoInteractive1Edit
          content={content}
          onChange={(content) => this.props.onChange(content)}
          labels={this.props.labels}
        />
      }


      {current_layer != null && active_mode === "preview" &&
        <div className="element-video-interactive-1-video" style={{
          height: this.getVideoHeight()
        }}>
          <div className="element-video-interactive-1-video-preload" style={{display: "none"}}>
            {this.props.content.layers.map(function (lyr, il) {
              return <video key={il} style={{
              }} preload="true" muted autoPlay src={_this.getVideoUrl(lyr.layer_asset)}></video>
            })}
          </div>
          <TransformWrapper
            key={scale}
            initialScale={scale}
            // minScale={mode === "edit" ? 0.5 : 1}
            minScale={scale}
            maxScale={scale}
            centerOnInit={false}
            doubleClick={{
              "disabled": true
            }}
            disabled={true}
          >
            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
              <>
                <TransformComponent>
                  <div className="element-video-interactive-1-container">
                    {/* <video controls src={this.getVideoUrl(content.video)}></video> */}
                    <video
                      key={current_layer.id}
                      style={{
                        width: current_layer_width,
                        height: current_layer_height
                      }}
                      id={`player-${current_layer.id}`}
                      src={this.getVideoUrl(current_layer.layer_asset)}
                      onClick={() => {
                        document.getElementById(`player-${current_layer.id}`).play()
                      }}
                    ></video>

                    {current_layer.interactions.filter(int => int.breakpoint === current_time).map(function (interaction, ind) {
                      return <div
                        key={ind}
                        className="element-video-interactive-1-interaction"
                        style={{
                          width: `${interaction.width}px`,
                          height: `${interaction.height}px`,
                          left: `${interaction.position_x}px`,
                          top: `${interaction.position_y}px`
                        }}
                        onClick={() => _this.onInteractionClick(interaction)}
                      >
                        
                      </div>
                    })}

                    {render_initial_frame &&
                      <div className="element-video-interactive-1-initial-frame">
                        <button className="element-video-interactive-1-initial-frame-play" onClick={() => this.onInitialFramePlay()}></button>
                      </div>
                    }
                  </div>
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </div>
      }

      
      {footerActionsTemplate}
    </div>)
  }
}
